import type { UseEnterpriseMyPageHeaderResult as MyEnterprisePageHeader } from 'bundles/composable-page-header-enterprise/contexts/EnterpriseMyPageHeaderContext';
import type { EnterpriseProgramsV1 } from 'bundles/naptimejs/resources/__generated__/EnterpriseProgramsV1';
import type { ThirdPartyOrganizationsV1 } from 'bundles/naptimejs/resources/__generated__/ThirdPartyOrganizationsV1';

export const mergeEnterpriseDataWithBackup = (
  bffData?: MyEnterprisePageHeader,
  backupProgram?: EnterpriseProgramsV1,
  backupThirdParty?: ThirdPartyOrganizationsV1
): MyEnterprisePageHeader => {
  /**
   * The old program provider doesn't distinguish between page program and
   * chosen program. Using same data for both!
   */
  const programFragment = backupProgram
    ? {
        __typename: 'EnterpriseProgram_EnterpriseProgram' as const,
        id: backupProgram?.id ?? '',
        slug: backupProgram?.metadata.slug ?? '',
        name: backupProgram?.metadata.name ?? '',
        launchedAt: backupProgram?.metadata.launchedAt
          ? new Date(backupProgram?.metadata.launchedAt * 1000).toISOString()
          : undefined,
        squareLogo: backupProgram?.metadata.squareLogo ?? undefined,
        rectangularLogo: backupProgram?.metadata.rectangularLogo ?? undefined,
        naptimeThirdPartyOrganization: {
          __typename: 'ThirdPartyOrganizationsV1' as const,
          id: backupThirdParty?.id ?? '',
          slug: backupThirdParty?.slug ?? '',
          name: backupThirdParty?.name ?? '',
          squareLogo: backupThirdParty?.squareLogo,
          rectangularLogo: backupThirdParty?.rectangularLogo,
        },
      }
    : undefined;

  /**
   * Interpolating bffData first with a backup or blank entry just in case
   * Always prefer existing BFF data if it's present!
   */
  return {
    currentPageProgram: bffData?.currentPageProgram ?? programFragment,
    chosenEnterpriseProgram: bffData?.chosenEnterpriseProgram ?? programFragment,
    chosenDegree: bffData?.chosenDegree ?? undefined,
    enrolledDegreePrograms: bffData?.enrolledDegreePrograms ?? undefined,
    enrolledEnterprisePrograms:
      bffData?.enrolledEnterprisePrograms ?? (programFragment ? [programFragment] : undefined),
    naptimeManagedThirdPartyOrganizations:
      bffData?.naptimeManagedThirdPartyOrganizations ??
      (backupThirdParty
        ? [
            {
              __typename: 'ThirdPartyOrganizationsV1' as const,
              id: backupThirdParty?.id ?? '',
              slug: backupThirdParty?.slug ?? '',
              name: backupThirdParty?.name ?? '',
              squareLogo: backupThirdParty?.squareLogo,
              rectangularLogo: backupThirdParty?.rectangularLogo,
            },
          ]
        : undefined),
    hasCheatingIncidents: bffData?.hasCheatingIncidents ?? undefined,
    canViewEducatorAdminLink: bffData?.canViewEducatorAdminLink ?? undefined,
    isCourseraPlusLearner: bffData?.isCourseraPlusLearner ?? undefined,
    courseraPlusSubscriptionCycle: bffData?.courseraPlusSubscriptionCycle ?? undefined,
    hasEnrolledPrograms: bffData?.hasEnrolledPrograms ?? undefined,
  };
};
